export const UNLOCK_WINDOW_MS = 24 * 60 * 60 * 1000;

export function remainingUnlockMs(requestedAt, now = Date.now()) {
  const start = typeof requestedAt === 'number'
    ? requestedAt
    : Date.parse(requestedAt);
  if (!Number.isFinite(start)) return 0;
  return Math.max(0, start + UNLOCK_WINDOW_MS - now);
}

export function splitCountdown(ms) {
  const total = Math.max(0, Math.floor(Number(ms) / 1000));
  return {
    hours: Math.floor(total / 3600),
    minutes: Math.floor((total % 3600) / 60),
    seconds: total % 60,
  };
}

export function padUnit(value) {
  return String(value).padStart(2, '0');
}
